import * as React from "react";
import get from "lodash/get";
import ReactMarkdown from "react-markdown";
import gfm from "remark-gfm";

import {
  getIsMemberTierLoading,
  getMemberTierCustomer,
} from "../../reducers/methods";
import { ComponentBase, ComponentBaseProps } from "../ComponentBase";
import { interpolate } from "../../utils/string";

export interface TierUpgradeRequirementProps extends ComponentBaseProps {
  classNames: string;
  name: string;
  label: string;
  style?: React.CSSProperties;
  highestTierStyle?: React.CSSProperties;
  highestTierText?: string;
  notAuthenticatedStyle?: React.CSSProperties;
  notAuthenticatedText?: string;
  tierUpgradeText?: string;

  align?: "flex-start" | "flex-end" | "center" | "baseline" | "stretch";
  isLoading: ReturnType<typeof getIsMemberTierLoading>;
  memberTierCustomer: ReturnType<typeof getMemberTierCustomer>;
  testMode?: string;
}

export class TierUpgradeRequirement extends ComponentBase<TierUpgradeRequirementProps> {
  renderText = (renderText: string) => {
    return (
      <div>
        <span className="Text-markdown-container">
          <ReactMarkdown skipHtml={true} linkTarget="_blank" plugins={[gfm]}>
            {renderText}
          </ReactMarkdown>
        </span>
      </div>
    );
  };

  renderNoTierUpgradeRequirement = () =>
    this.renderText(this.props.highestTierText || "");

  renderNotAuthenticated = () =>
    this.renderText(this.props.notAuthenticatedText || "");

  renderTierUpgradeRequirement = () => {
    const { data, tierUpgradeText } = this.props;

    const interpolatedString = interpolate(tierUpgradeText || "", {
      ...data,
    });

    return this.renderText(interpolatedString);
  };

  // tslint:disable-next-line: cyclomatic-complexity
  render() {
    const {
      classNames,
      data,
      isLoading,
      isEditing,
      memberTierCustomer,
      style,
      testMode,
    } = this.props;

    const isCustomerAuthenticated = get(data, "customer.authenticated", false);
    const unavailableReason = get(
      memberTierCustomer,
      "variables.nextTier.unavailableReason",
      ""
    );
    const highestTier = unavailableReason === "maxTier";
    const hasNextTier =
      !unavailableReason && get(memberTierCustomer, "variables.nextTier.name");

    if (isEditing) {
      const notAuthenticated = testMode === "notAuthenticated";
      const highestTier = testMode === "highestTier";
      const tierUpgradeRequirement = testMode === "default" || !testMode;

      return (
        <div
          id={this.props.configName}
          className={`MemberTier-container  ${classNames || ""}`}
          onDragStart={this.onDragStart}
          onMouseDown={this.onMouseDown}
          ref={(component) => (this.component = component)}
          style={style}
        >
          {notAuthenticated && this.renderNotAuthenticated()}
          {highestTier &&
            !notAuthenticated &&
            this.renderNoTierUpgradeRequirement()}
          {tierUpgradeRequirement && this.renderTierUpgradeRequirement()}
        </div>
      );
    }

    if (isLoading) {
      return "...";
    }

    return (
      <div
        id={this.props.configName}
        onDragStart={this.onDragStart}
        onMouseDown={this.onMouseDown}
        ref={(component) => (this.component = component)}
        className={`TierUpgradeRequirement-div-container`}
        style={style}
      >
        {!isCustomerAuthenticated && this.renderNotAuthenticated()}
        {isCustomerAuthenticated &&
          highestTier &&
          this.renderNoTierUpgradeRequirement()}
        {isCustomerAuthenticated &&
          hasNextTier &&
          this.renderTierUpgradeRequirement()}
      </div>
    );
  }
}
